import type { ParamMatcher } from '@sveltejs/kit';

export const match: ParamMatcher = (param) => {
	const languages = ['en', 'fr', 'ar'];
	return languages.includes(param);
};
